import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "UserSearchWrapper",
  ref: "searchWrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			!_ctx.isLoading ? 'SearchContainer' : ''
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "SearchIcon" }, [
        _createElementVNode("i", { class: "lnr-magnifier" })
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          type: "text",
          class: "CampaignEditorInputField",
          ref: "tableEntitiesSearchInput",
          placeholder: "Search by organisation name, programme name, or ID",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setSearchTerm && _ctx.setSearchTerm(...args)))
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
      ], 512 /* NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}